// Multiplier to convert new GBP (1 GBP = 100 pence) values to legacy format (1 GBP = 10000 pence) for backend compatibility
export const LEGACY_GBP_TO_PENCE_MULTIPLIER = 100;
